module.exports = __webpack_public_path__ + "static/img/12.18492ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/1/eng/12.png
// module id = VRqX
// module chunks = 0